import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { createRef, Component } from 'react';
import OtherClickListener from '../../../events/OtherClickListener';
import { propFunc, propShape } from '../../../helpers/custom-prop-types';
import NotificationIcon from '../../Icon/Svg/NotificationIcon';
import PersonIcon from '../../Icon/Svg/PersonIcon';
import Hover from '../../Ui/System/Hover';
import HeaderLoginSideMenuContent from './HeaderLoginSideMenuContent';
import HeaderLoginSideMenuNotification from './HeaderLoginSideMenuNotification';
class HeaderLoginSideMenu extends Component {
    constructor(props) {
        super(props);
        this.toggleMenu = (e) => {
            const { openMode } = this.state;
            const { value } = e.currentTarget;
            if (openMode === value) {
                this.setState({ openMode: 'hide' });
            }
            else {
                this.setState({ openMode: value });
            }
        };
        this.hideMenu = () => {
            this.setState({ openMode: 'hide' });
        };
        this.clickRef = createRef();
        this.clickListenerNo = null;
        this.state = {
            openMode: 'hide',
        };
    }
    componentDidMount() {
        this.clickListenerNo = OtherClickListener.setListener(this.clickRef.current, this.hideMenu);
    }
    componentWillUnmount() {
        this.setState({ openMode: 'hide' });
        OtherClickListener.deleteListener(this.clickListenerNo);
    }
    render() {
        const { onClickLogout, profile } = this.props;
        const { openMode } = this.state;
        return (_jsxs("div", Object.assign({ className: `header_side_menu is_${openMode}`, ref: this.clickRef }, { children: [_jsx("div", Object.assign({ className: 'header_side_menu_top_button_box' }, { children: _jsxs("ul", Object.assign({ className: 'button_list' }, { children: [_jsx(Hover, { children: _jsx("li", Object.assign({ className: 'button_col' }, { children: _jsx("button", Object.assign({ className: 'notification_button', onClick: this.toggleMenu, type: 'button', value: 'notification' }, { children: _jsx(NotificationIcon, {}) })) })) }), _jsx("li", Object.assign({ className: 'button_col' }, { children: _jsxs("button", Object.assign({ className: 'open_button', onClick: this.toggleMenu, type: 'button', value: 'menu' }, { children: [_jsx("div", Object.assign({ className: 'person_icon_circle' }, { children: _jsx(PersonIcon, {}) })), _jsx("i", Object.assign({ className: 'material-icons is_menu' }, { children: "menu" })), _jsx("i", Object.assign({ className: 'material-icons is_menu_close' }, { children: "close" }))] })) }))] })) })), _jsxs("div", Object.assign({ className: 'header_side_menu_wrapper' }, { children: [_jsx("div", { className: 'header_side_menu_bg', onClick: this.hideMenu, role: 'presentation' }), _jsx(HeaderLoginSideMenuNotification, { hideMenu: this.hideMenu }), _jsx(HeaderLoginSideMenuContent, { hideMenu: this.hideMenu, onClickLogout: onClickLogout, profile: profile })] }))] })));
    }
}
HeaderLoginSideMenu.propTypes = {
    onClickLogout: propFunc().isRequired,
    profile: propShape().isRequired,
};
export default HeaderLoginSideMenu;
